<template>
    <div class="badge-wrapper">
        <Badge color="green" :text="t({ key: 'checkout.flexible_ticket' })" :size="size" />
    </div>
</template>

<script lang="ts">
    import Badge from '@ui/components/Badge/Badge.vue';
    import { t } from '@shared/helpers/translation';
    import { PropType } from 'vue';
    import { Size as BadgeSize } from '@ui/components/Badge/Badge.interfaces';

    export default {
        name: 'RebookableBadge',
        methods: { t },
        components: { Badge },
        props: {
            size: {
                type: String as PropType<BadgeSize>,
                default: 's',
            },
        },
    };
</script>

<style>
    .badge-wrapper {
        width: fit-content;
    }
</style>
